import React from 'react';
import ReactDOM from 'react-dom';
import Router from './Router';
import './public.css';
import './util/flexible';
import axios from 'axios'; // 引入axios
import './i18n';
import md5 from 'js-md5';
import { delCookie } from './util/cookie';
import { projectInit } from './util/projectInit';
import { reportEvent } from './util/util';
try {
  projectInit();
} catch (error) {
  console.log('projectInit error', error);
  reportEvent({ name: 'projectInitError', ext2: { error } });
}
// 将md5加密方法挂载到React组件原型上，目前只在helpFeedback页面中使用了这个方法
React.Component.prototype.$md5 = md5;
// 删除LG侧筛选页存储的聚焦元素
// 这个筛选页面目前没有使用路由缓存的形式，看之后可不可以切换为路由缓存
// 目前是出页面需要保存当前聚焦状态会将聚焦元素存在本地，然后返回时再取出使用
// 这个主要是目前点击home键退出应用并没有处理，消除该种情况下从主页进筛选页跳到对应聚焦位置的影响
delCookie('filterPageLG_current_focus');
// 清空之前的主页缓存数据
localStorage.removeItem('allInterfaceDataCache');

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      registration.unregister().then(() => {
        reportEvent({ name: 'serviceWorkerUnregisterSuccess' });
      })
        .catch((error) => {
          console.error('Service Worker registration error:', error);
          reportEvent({ name: 'serviceWorkerUnregisterError', ext2: { error } });
        });
    });
  })
    .catch((error) => {
      console.error('Service Worker getRegistrations error:', error);
      reportEvent({ name: 'serviceWorkerGetRegistrationsError', ext2: { error } });
    });
}

if ('caches' in window) {
  caches.keys().then((names) => {
    names.forEach((name) => {
      caches.delete(name).then(() => {
        reportEvent({ name: 'cacheDeletionSuccess', ext2: { cacheName: name } });
      })
        .catch((error) => {
          console.error('Cache deletion error:', error);
          reportEvent({ name: 'cacheDeletionError', ext2: { error, cacheName: name } });
        });
    });
  })
    .catch((error) => {
      console.error('Cache keys error:', error);
      reportEvent({ name: 'cacheKeysError', ext2: { error } });
    });
}

axios.defaults.withCredentials = true;
// 挂载页面
ReactDOM.render(<Router />, document.getElementById('root'), async () => {
  const { appLaunchReport } = await import('./util/appLaunch');
  // 应用启动上报
  appLaunchReport();
});
